module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/industry-02-999256b4b06dd1e1e3e461fb0d882b8e.png";